import React from "react";
import { PackingSlipModel } from "../../../dailyPlanning/domain/models/packingSlipModel";
import { Document } from "@react-pdf/renderer";
import { PackingSlipPdfPage } from "./PackingSlipPdfPage";

interface props {
  packingSlips: PackingSlipModel[];
}

export const PackingSlipPdf = ({ packingSlips }: props) => {
  return (
    <Document>
      {packingSlips.map((packingSlip) => (
        <PackingSlipPdfPage key={packingSlip.id} packingSlip={packingSlip} />
      ))}
    </Document>
  );
};
